import { render } from "./apiPackage.vue?vue&type=template&id=8a2091ac&scoped=true"
import script from "./apiPackage.vue?vue&type=script&lang=js"
export * from "./apiPackage.vue?vue&type=script&lang=js"

import "./apiPackage.vue?vue&type=style&index=0&id=8a2091ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2091ac"]])

export default __exports__